import type { IMenuItemEntry } from '@move-frontend/contentful';
import React from 'react';
import {
	NavItemType,
	useNavigationContext,
} from '../../context/NavigationContext';
import type { ISubMenuItemConfig } from '../../shared/NavigationSubMenu';
import { SectionWithSubmenuNavItem } from '../../shared/SectionWithSubmenuNavItem';
import { StyledMainNavigationList } from '../MainNavigationList';
import { SectionWithoutSubmenuNavItem } from './SectionWithoutSubmenuNavItem';

interface ISectionsNavigationListProps {
	isMobileView?: boolean;
	onItemClick?: () => void;
}
export const SectionsNavigationList = ({
	isMobileView = false,
	onItemClick,
}: ISectionsNavigationListProps) => {
	const {
		sections,
		selectedItem,
		isSectionSubMenuOpen,
		handleNavigationItemClick,
	} = useNavigationContext();

	const getSubMenuItems = (menuItem: IMenuItemEntry) =>
		menuItem.fields.subMenuItems;

	const getSubMenuConfigItems = (
		subMenuItems: IMenuItemEntry[],
	): ISubMenuItemConfig[] =>
		subMenuItems.map((subMenuItem) => ({
			id: subMenuItem.id,
			pageId: subMenuItem.fields.page?.fields.id || '',
			title: subMenuItem.fields.title,
		}));

	// Do not render an empty <ul> according to accessibility guideline
	// "ARIA required owned elements"
	// https://www.w3.org/WAI/standards-guidelines/act/rules/bc4a75/proposed/
	if (sections.length === 0) {
		return null;
	}

	return (
		<StyledMainNavigationList id="menu_nav_list" role="menubar">
			{sections.map((section) => {
				const subMenuItems = getSubMenuItems(section) as
					| IMenuItemEntry[]
					| undefined;
				if (subMenuItems && subMenuItems.length > 0) {
					const subMenuConfigItems = getSubMenuConfigItems(subMenuItems);
					return (
						<SectionWithSubmenuNavItem
							key={section.fields.page?.fields.id}
							title={section.fields.title}
							contentWidth="300px"
							relativeSubMenu={isMobileView}
							subMenuItems={subMenuConfigItems}
							open={isSectionSubMenuOpen && selectedItem === section}
							onItemClick={onItemClick}
							onClick={() =>
								handleNavigationItemClick({
									type: NavItemType.Section,
									item: section,
								})
							}
						/>
					);
				}
				return (
					<SectionWithoutSubmenuNavItem
						id={section.fields.page?.fields?.id || ''}
						key={section.fields.page?.fields?.id}
						item={section}
					/>
				);
			})}
		</StyledMainNavigationList>
	);
};
